import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import Row from './Row';

const TableBody = ({
  RowComponent,
  getRowId,
  rows,
  columns,
  selectable,
  numberOfFrozenColumns = 0
}) => /*#__PURE__*/_jsx("tbody", {
  children: rows.map((row, index) => {
    const rowId = getRowId(row);
    return /*#__PURE__*/_jsx(Row, {
      RowComponent: RowComponent,
      rowId: rowId,
      rowIndex: index,
      row: row,
      columns: columns,
      selectable: selectable,
      numberOfFrozenColumns: numberOfFrozenColumns
    }, rowId);
  })
});

export default /*#__PURE__*/memo(TableBody);